<template>
    <div class="container">
        <div class="container-header">
            <div class="search">
                <div class="search-handle">
                    <el-button type="primary" size="mini" @click="addHandle()">{{ $t('add') }}</el-button>
                </div>
            </div>
        </div>
        <div class="container-main">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                row-key="id"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                <el-table-column type="index" align="center" width="60"></el-table-column>
                <el-table-column prop="name" :label="$t('permissionName')" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="code" :label="$t('code')" align="center" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="sort" :label="$t('sortValue')" align="center" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column
                    class-name="handle"
                    :label="$t('handle')"
                    align="center"
                    width="220">
                    <template slot-scope="scope">
                        <el-button type="text"
                                   size="mini"
                                   @click="addHandle(scope.row.id, scope.row.name)">{{$t('addChildClassify')}}</el-button>
                        <el-button type="text"
                                   size="mini"
                                   @click="editHandle(scope.row.id)">{{$t('edit')}}</el-button>
                        <el-button
                            class="red"
                            type="text"
                            size="mini"
                            @click="deleteHandle(scope.row.id)">{{$t('delete')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 添加 -->
        <Add
            :parent-dialog="addDialog"
            :node-id="itemId"
            :node-name="itemName"
            @parent-update="getListData"
            @parent-close="addDialog = false"/>
        <!-- 编辑 -->
        <Edit
            :parent-dialog="editDialog"
            :node-id="itemId"
            @parent-update="getListData"
            @parent-close="editDialog = false"/>
    </div>
</template>

<script>
import {queryPermissionTree, deletePermission} from "@/api/modules/user";
import Add from '@/components/employee/permission/Add'
import Edit from '@/components/employee/permission/Edit'

export default {
    name: "Permission",
    // 组件
    components: {
        Add,
        Edit,
    },
    props: {},
    data() {
        return {
            tableData: [],
            addDialog: false,
            itemId: '0',
            itemName: '',
            editDialog: false,
            paperDialog: false
        };
    },
    // 计算属性
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        // 获取数据列表
        getListData() {
            queryPermissionTree().then(res => {
                if (Number(res.code) === 20000) {
                    this.tableData = res.data
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        // 添加
        addHandle (id = '0', name = '') {
            this.itemId = id
            this.itemName = name
            this.addDialog = true
        },
        // 编辑
        editHandle (id) {
            this.itemId = id
            this.editDialog = true
        },
        // 删除
        deleteHandle (id) {
            this.$confirm(this.$t('deleteItemHint'), this.$t('hint'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                deletePermission(id).then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        this.getListData()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => {})
        },
    },
    // 创建完成
    created() {
    },
    // 挂载完成
    mounted() {
        // 获取列表数据
        this.getListData()
    },
    // 销毁之前
    beforeDestroy() {
    }
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/base-column.scss';

</style>
